import {useEffect, useState} from 'react';

/**
 * `matchMedia` as a hook — the plain replacement for MUI's `useMediaQuery`. Starts `false`
 * (as MUI's did) so the server render and the first client render agree, then follows the query.
 */
export default function useMatchMedia(query: string): boolean {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
        const list = globalThis.matchMedia(query);
        const update = () => setMatches(list.matches);
        update();
        list.addEventListener('change', update);
        return () => list.removeEventListener('change', update);
    }, [query]);

    return matches;
}
